// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3DR3e","info":"UpdateTermsInfo_info__2XbWC"};